import { IconButton as MuiIconButton, IconButtonProps as MuiIconButtonProps } from '@mui/material';
import React from 'react';
import Icon from './Icon';

type CustomIconButtonProps = Omit<MuiIconButtonProps, 'name'> & {
    iconName: Parameters<typeof Icon>[0]['name'];
    iconProps?: Partial<Parameters<typeof Icon>[0]>;
};

const IconButton: React.FC<CustomIconButtonProps> = ({ iconName, iconProps, ...muiIconButtonProps }) => {
    return (
        <MuiIconButton size="small" {...muiIconButtonProps}>
            <Icon name={iconName} {...iconProps} />
        </MuiIconButton>
    );
};

export default IconButton;